import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";

/**
 * Lazy-loaded component for rendering the traffic monitoring dashboard.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} TrafficDashboardPage - Lazy-loaded TrafficDashboardPage component.
 */
const TrafficDashboardPage = Loadable(
  lazy(() => import("./TrafficDashboardPage"))
);

/**
 * Array containing route definitions for the traffic monitoring pages.
 * @constant {Object[]} TrafficRoutes - Array of traffic route objects.
 * @property {string} TrafficRoutes[].path - The path of the traffic route.
 * @property {React.ReactElement} TrafficRoutes[].element - The React element to be rendered for the traffic route.
 */
const TrafficRoutes = [
  {
    path: "",
    element: <TrafficDashboardPage />,
  },
];

export default TrafficRoutes;
